import { useContext } from "react";
import { WaitingRoomPatient } from "src/api/types";
import { WaitingRoomContext } from "./WaitingRoomProvider";

export function useWaitingRoom<T>(
  selector: (waitingRoomPatient: WaitingRoomPatient) => T
) {
  const patient = useContext(WaitingRoomContext);

  if (patient == null) {
    throw new Error("useWaitingRoom is used outside of WaitingRoomProvider");
  }

  return selector(patient);
}
